module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent",
    staticStyle: {
      "background-color": "#F0F0F0"
    }
  }, [_c('pageTitle', {
    attrs: {
      "title": "微信支付"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "2.2rem",
      "line-height": "2.2rem",
      "text-align": "center",
      "background-color": "#FFF"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "0.28rem",
      "color": "#333333",
      "padding-right": "10px"
    }
  }, [_vm._v("￥")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "0.64rem",
      "color": "#333333"
    }
  }, [_vm._v(_vm._s(_vm.totalFee))])]), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "background-color": "#FFF"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "92%",
      "height": "1.14rem",
      "line-height": "1.14rem",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.28rem",
      "color": "#999999"
    }
  }, [_vm._v("订单号：")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.28rem",
      "color": "#333333"
    }
  }, [_vm._v(_vm._s(_vm.parentNo))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "92%",
      "height": "0.88rem",
      "line-height": "0.88rem",
      "margin-left": "auto",
      "margin-right": "auto",
      "background-color": "#1AAD19",
      "margin-top": "0.5rem",
      "border-radius": "0.08rem",
      "font-size": "0.32rem",
      "color": "#FFF",
      "text-align": "center"
    },
    on: {
      "click": _vm.wepay
    }
  }, [(_vm.allowPay) ? _c('p', [_vm._v("微信支付")]) : _vm._e(), _vm._v(" "), (!_vm.allowPay) ? _c('p', [_vm._v("微信支付中...")]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "message": _vm.TellUser,
      "id": "alertline"
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.allowPay) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "bottom": "0",
      "left": "0",
      "right": "0",
      "background": "#000",
      "opacity": "0.6"
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "92%",
      "margin-left": "auto",
      "margin-right": "auto",
      "height": "0.68rem",
      "margin-top": "0.4rem",
      "font-size": "0.24rem"
    }
  }, [_c('li', {
    staticStyle: {
      "list-style-type": "disc"
    }
  }, [_vm._v("格林豪泰酒店集团不会记录您的任何微信信息，所有信息均由加密通道传递给微信支付")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "92%",
      "margin-left": "auto",
      "margin-right": "auto",
      "height": "0.34rem",
      "line-height": "0.34rem",
      "margin-top": "0.4rem",
      "font-size": "0.24rem"
    }
  }, [_c('li', {
    staticStyle: {
      "list-style-type": "disc"
    }
  }, [_vm._v("本服务由微信支付提供技术支持")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-50bd5806!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/wepay.vue
// module id = 1500
// module chunks = 18